<script setup lang="ts">
import { computed } from "vue"
import { formatNumber } from "../utils/format"

const props = defineProps<{
  active: number | null | undefined
  label?: string
  max: number
}>()

const activeCount = computed(() => Math.max(0, props.active ?? 0))
const maxCount = computed(() => Math.max(1, props.max))
const slots = computed(() => Array.from({ length: maxCount.value }, (_, index) => index))
const meterLabel = computed(
  () => props.label ?? `Connections ${formatNumber(activeCount.value)} / ${formatNumber(maxCount.value)}`
)
</script>

<template>
  <UTooltip :text="meterLabel" :ui="{ content: 'dashboard-tooltip-content', text: 'dashboard-tooltip-text' }">
    <div class="inline-flex h-6 items-center gap-1" :aria-label="meterLabel">
      <span
        v-for="slot in slots"
        :key="slot"
        class="block h-5 w-1.5 border border-(--dash-line)"
        :class="slot < activeCount ? 'bg-(--dash-success)' : 'bg-[rgba(241,243,242,0.04)]'"
      />
    </div>
  </UTooltip>
</template>
